//designer timer Jquery to javascript
document.addEventListener("DOMContentLoaded", function() {
  // Convert jQuery $( '#set-time' ).val() to vanilla JS
  var setTimeElements = document.querySelectorAll('#set-time');
  setTimeElements.forEach(function(setTimeElement) {
    var minutes = setTimeElement.value;
    var target_date = new Date().getTime() + ((minutes * 60) * 1000); // set the countdown date
    var time_limit = ((minutes * 60) * 1000);

    // set actual timer
    setTimeout(function() {
      document.getElementById("left").innerHTML = "Timer Stopped";
    }, time_limit);

    var days, hours, minutes, seconds; // variables for time units

    var countdown = setTimeElement.nextElementSibling.querySelector("#tiles"); // get tag element

    function getCountdown() {
      // find the amount of "seconds" between now and target
      var current_date = new Date().getTime();
      var seconds_left = (target_date - current_date) / 1000;

      if (seconds_left >= 0) {
        console.log(time_limit);
        if ((seconds_left * 1000) < (time_limit / 2)) {
          countdown.classList.remove('color-full');
          countdown.classList.add('color-half');
        }
        if ((seconds_left * 1000) < (time_limit / 4)) {
          countdown.classList.remove('color-half');
          countdown.classList.add('color-empty');
        }

        days = pad(parseInt(seconds_left / 86400));
        seconds_left = seconds_left % 86400;

        hours = pad(parseInt(seconds_left / 3600));
        seconds_left = seconds_left % 3600;

        minutes = pad(parseInt(seconds_left / 60));
        seconds = pad(parseInt(seconds_left % 60));

        // format countdown string + set tag value
        countdown.innerHTML = "<span>" + hours + "</span><span>" + minutes + "</span><span>" + seconds + "</span>";
      }
    }

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }

    getCountdown();
    setInterval(getCountdown, 1000);
  });
});






//AK custom JS
document.addEventListener('DOMContentLoaded', function() {
   const startButtons = document.querySelectorAll('.quiz_form_steps .form-details .form_steps_first button.form_start_btn');
  
  startButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const formStepsFirst = button.closest('.form_steps_first');
      const formDetails = button.closest('.form-details');
      const formInnerAround = formDetails.querySelector('.form-inner-around');
      
      formStepsFirst.classList.add('hidden');
      formInnerAround.querySelector('.quiz_nav_bar').classList.remove('hidden');
      const formStepsSecond = formInnerAround.querySelector('.form_steps_second');
      formStepsSecond.classList.remove('hidden');
      formStepsSecond.classList.add('active');
      formInnerAround.querySelector('.main_next_prev_btn').classList.remove('hidden');
    });
  });

  const quizAnswerItems = document.querySelectorAll('.quiz_form_steps .form-details .form_step ul.quiz-answer li');
  
  quizAnswerItems.forEach(function(item) {
    item.addEventListener('click', function() {
      // Remove 'selected' class from all siblings
      const siblings = item.parentNode.querySelectorAll('li');
      siblings.forEach(function(sibling) {
        sibling.classList.remove('selected');
        sibling.style.border = '1px solid #d2d2d2';
      });
      
      // Add 'selected' class to the clicked item
      item.classList.add('selected');
    });
  });

  //next button
  const nextFormButtons = document.querySelectorAll('.quiz_form_steps .form-details .form-inner-around .main_next_prev_btn .next_form_btn');
  
  nextFormButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const formDetails = button.closest('.form-details');

      if (formDetails.querySelector('.form_steps_second').classList.contains('active')) {
        const inputVal = formDetails.querySelector('.form_steps_second input').value;
        
        if (!inputVal) {
          formDetails.querySelector('.form_steps_second input').style.border = '1px solid red';
        } else {
          formDetails.querySelector('.curr_pet_name').innerHTML = inputVal;
          formDetails.querySelector('.form_steps_second').classList.add('hidden');
          formDetails.querySelector('.form_steps_third').classList.remove('hidden');
          formDetails.querySelector('.form-inner-around .form_steps_second').classList.remove('active');
          formDetails.querySelector('.form-inner-around .form_steps_third').classList.add('active');
          Array.from(formDetails.querySelectorAll('.form-inner-around .quiz_nav_bar ul li')).slice(0, 2).forEach(li => li.classList.add('nav_active'));
          formDetails.querySelector('.form_steps_second input').style.border = '1px solid #d2d2d2';
        }
      } else if (formDetails.querySelector('.form_steps_third').classList.contains('active')) {
        const selectedCount = formDetails.querySelectorAll('.form_steps_third ul li.selected').length;
        
        if (selectedCount > 0) {
          formDetails.querySelector('.form_steps_third').classList.add('hidden');
          formDetails.querySelector('.form_steps_four').classList.remove('hidden');
          formDetails.querySelector('.form-inner-around .form_steps_third').classList.remove('active');
          formDetails.querySelector('.form-inner-around .form_steps_four').classList.add('active');
          Array.from(formDetails.querySelectorAll('.form-inner-around .quiz_nav_bar ul li')).slice(0, 3).forEach(li => li.classList.add('nav_active'));
        } else {
          formDetails.querySelectorAll('.form_steps_third ul li').forEach(li => li.style.border = '1px solid red');
        }
      } else if (formDetails.querySelector('.form_steps_four').classList.contains('active')) {
        const selectedCount = formDetails.querySelectorAll('.form_steps_four ul li.selected').length;
        
        if (selectedCount > 0) {
          formDetails.querySelector('.form_steps_four').classList.add('hidden');
          formDetails.querySelector('.form_steps_fifth').classList.remove('hidden');
          formDetails.querySelector('.form-inner-around .form_steps_four').classList.remove('active');
          formDetails.querySelector('.form-inner-around .form_steps_fifth').classList.add('active');
          Array.from(formDetails.querySelectorAll('.form-inner-around .quiz_nav_bar ul li')).slice(0, 4).forEach(li => li.classList.add('nav_active'));
        } else {
          formDetails.querySelectorAll('.form_steps_four ul li').forEach(li => li.style.border = '1px solid red');
        }
      } else if (formDetails.querySelector('.form_steps_fifth').classList.contains('active')) {
        const selectedCount = formDetails.querySelectorAll('.form_steps_fifth ul li.selected').length;
        
        if (selectedCount > 0) {
          formDetails.querySelector('.form_steps_fifth').classList.add('hidden');
          formDetails.querySelector('.form_steps_sixth').classList.remove('hidden');
          formDetails.querySelector('.form-inner-around .form_steps_fifth').classList.remove('active');
          formDetails.querySelector('.form-inner-around .form_steps_sixth').classList.add('active');
          Array.from(formDetails.querySelectorAll('.form-inner-around .quiz_nav_bar ul li')).slice(0, 5).forEach(li => li.classList.add('nav_active'));
        } else {
          formDetails.querySelectorAll('.form_steps_fifth ul li').forEach(li => li.style.border = '1px solid red');
        }
      } else if (formDetails.querySelector('.form_steps_sixth').classList.contains('active')) {
        const selectedCount = formDetails.querySelectorAll('.form_steps_sixth ul li.selected').length;
        
        if (selectedCount > 0) {
          formDetails.querySelector('.form_steps_sixth').classList.add('hidden');
          formDetails.querySelector('.form_steps_eight').classList.remove('hidden');
          formDetails.querySelector('.form-inner-around .form_steps_sixth').classList.remove('active');
          formDetails.querySelector('.form-inner-around .form_steps_eight').classList.add('active');
          Array.from(formDetails.querySelectorAll('.form-inner-around .quiz_nav_bar ul li')).slice(0, 6).forEach(li => li.classList.add('nav_active'));
        } else {
          formDetails.querySelectorAll('.form_steps_sixth ul li').forEach(li => li.style.border = '1px solid red');
        }
      } else if (formDetails.querySelector('.form_steps_eight').classList.contains('active')) {
        const selectedCount = formDetails.querySelectorAll('.form_steps_eight ul li.selected').length;
       
        
        if (selectedCount > 0) {
          
          formDetails.querySelector('.form_steps_eight').classList.add('hidden');
          const btnUrl = formDetails.querySelector('.form_steps_eight ul li.selected').getAttribute('data-href');
          const btnStep = formDetails.querySelector('.form_steps_eight ul li.selected').getAttribute('data-step');
          if (btnStep === 'final_mats') {
            formDetails.querySelector('.form_steps_last.final_mats').classList.remove('hidden');
          } else if (btnStep === 'final_bedsheet') {
            formDetails.querySelector('.form_steps_last.final_bedsheet').classList.remove('hidden');
          } else if (btnStep === 'final_bundle') {
            formDetails.querySelector('.form_steps_last.final_bundle').classList.remove('hidden');
          }

          
          
          formDetails.querySelector('.form-inner-around .form_steps_eight').classList.remove('active');
          formDetails.querySelector('.form-inner-around .quiz_nav_bar').classList.add('hidden');
          formDetails.querySelector('.main_next_prev_btn').classList.add('hidden');
        } else {
          formDetails.querySelectorAll('.form_steps_eight ul li').forEach(li => li.style.border = '1px solid red');
        }
      }
    });
  });

  //previous button
  const prevFormButtons = document.querySelectorAll('.quiz_form_steps .form-details .form-inner-around .main_next_prev_btn .previous_form_btn');

  prevFormButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const formDetails = button.closest('.form-details');
      const quizNavBar = formDetails.querySelector('.form-inner-around .quiz_nav_bar');
      const mainNextPrevBtn = formDetails.querySelector('.main_next_prev_btn');
      const activeStep = formDetails.querySelector('.form-inner-around .form_step.active');

      if (formDetails.querySelector('.form_steps_second').classList.contains('active')) {
        formDetails.querySelector('.form_steps_second').classList.remove('active');
        formDetails.querySelector('.form_steps_second').classList.add('hidden');
        formDetails.querySelector('.form_steps_first').classList.remove('hidden');
        quizNavBar.classList.add('hidden');
        mainNextPrevBtn.classList.add('hidden');
      } else if (activeStep) {
        const previousSteps = Array.from(activeStep.previousElementSibling.closestAll('.form_step'));
        const previousStepsLength = previousSteps.length;

        formDetails.querySelectorAll('.form-inner-around .quiz_nav_bar ul li').forEach((li, index) => {
          li.classList.toggle('nav_active', index < previousStepsLength);
        });

        const prevStep = activeStep.previousElementSibling;
        if (prevStep) {
          prevStep.classList.remove('hidden');
          prevStep.classList.add('active');
          activeStep.classList.add('hidden');
          activeStep.classList.remove('active');
        }
      }
    });
  });

  
});
//End AK custom JS